import React from 'react'

function Guides({ setClick }) {

    return (
        <div className=" delete_activity_transprant_body ">
            <img
                style={{ position: "relative", top: "-40%", left: "85%" }}
                src="/images/cross.svg"
                className="btn-light p-2 rounded-circle"
                alt=""
                onClick={(e) => setClick(false)}
            />

            <div className=" p-3 d-flex align-items-center justify-content-center flex-column shadow">
                <img src='images/guideinfo.png' alt='' style={{ width: "100%" }}></img>
            </div>
        </div>
    )
}

export default Guides